const showMoreButton = document.getElementById('show-more-button');
const allCards = document.querySelectorAll('.trustees__card') ?? [];
const resultText = document.getElementById('show-more-result');

const visibleCount = 6;
const cardsToShowPerClick = 6;
let currentIndex = visibleCount;

if (allCards.length > 0 && resultText != null) {
    allCards.forEach(card => card.classList.add('hidden'));

    for (let i = 0; i < visibleCount; i++) {
        if (allCards[i]) {
            allCards[i].classList.remove('hidden');
        }
    }
    resultText.textContent = `Visar ${visibleCount} av ${allCards.length} resultat`;

    if (showMoreButton) {
        showMoreButton.addEventListener('click', function () {
            for (let i = currentIndex; i < currentIndex + cardsToShowPerClick && i < allCards.length; i++) {
                allCards[i].classList.remove('hidden');
            }

            currentIndex += cardsToShowPerClick;

            resultText.textContent = `Visar ${Math.min(currentIndex, allCards.length)} av ${allCards.length} resultat`;

            if (currentIndex >= allCards.length) {
                showMoreButton.style.display = 'none';
            }
        });
    }
}